"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardVictoryPoints = void 0;
var vue_1 = require("vue");
var CardRenderDynamicVictoryPoints_1 = require("../../cards/render/CardRenderDynamicVictoryPoints");
var CardRenderItemComponent_1 = require("./CardRenderItemComponent");
exports.CardVictoryPoints = vue_1.default.component('CardPoints', {
    props: {
        victoryPoints: {
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_1.CardRenderItemComponent,
    },
    methods: {
        getClasses: function () {
            var classes = ['card-points'];
            if (this.isObject()) {
                var item = this.victoryPoints;
                if (item.anyPlayer) {
                    classes.push('card-points-big');
                    classes.push('red-outline');
                }
                else {
                    classes.push('card-points-normal');
                }
            }
            else {
                classes.push('card-points-big');
            }
            return classes.join(' ');
        },
        isObject: function () {
            return this.victoryPoints instanceof CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints;
        },
    },
    template: "\n      <div v-if=\"isObject() && !this.victoryPoints.targetOneOrMore\" :class=\"getClasses()\">\n        <div>{{ this.victoryPoints.getPointsHtml() }}</div><CardRenderItemComponent v-if=\"this.victoryPoints.item !== undefined\" :item=\"this.victoryPoints.item\" /></div>\n      <div v-else-if=\"isObject() && this.victoryPoints.targetOneOrMore\" :class=\"getClasses()\">\n        <div class=\"card-points-item-first\"><CardRenderItemComponent v-if=\"this.victoryPoints.item !== undefined\" :item=\"this.victoryPoints.item\" />*:3</div>\n      </div>\n      <div v-else :class=\"getClasses()\">{{ this.victoryPoints }}</div>\n    ",
});
//# sourceMappingURL=CardVictoryPoints.js.map